import React from "react";

class ThreeCanvasErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any child components and re-renders with an error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    let Raven = window.Raven || { captureException: () => {} };
    Raven.captureException(error);
  }

  render() {
    if (this.state.error) {
      // Fallback UI if an error occurs
      //<img className="d-block w-100" src="https://via.placeholder.com/540x440"/>
      return (
        <div className="three-warning-error">
          <div className="alert alert-danger" role="alert">
            <h6>Sorry, something went wrong with the preview!</h6>
            <p>
              You can try to reload the page to fix this. Contact us at{" "}
              <a href="mailto:hi@asabove.us">hi@asabove.us</a> if the error
              persists. You can also try this page on a different device.
            </p>
          </div>
        </div>
      );
    } else {
      // component normally just renders children
      return this.props.children;
    }
  }
}

export default ThreeCanvasErrorBoundary;
